import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useGetAdspaceListQuery } from 'entities/Adspace';
import { useGetAppConfigQuery } from 'shared/api';
import { META_REQUEST_LIMIT } from 'shared/consts';
import { EMainRoutes, EYmEvents, EYmEventsGoals, EYmEventsO1, EYmEventsO2, EYmEventsO4 } from 'shared/typings';
import { sendYmEvent } from 'shared/utils';

export const useRedirectToCreateAdspace = () => {
	const [searchParams] = useSearchParams();
	const createdAdspaceId = searchParams.get('adspaceId') || '';
	const isCreateAdspace = searchParams.get('isCreateAdspace') || '';
	const { data: appConfig } = useGetAppConfigQuery();

	const createdUserKey = `createdUser_${appConfig?.user?.user_id || ''}`;
	const createdAdspacesKey = `createdAdspaces_${appConfig?.user?.user_id || ''}`;

	useEffect(() => {
		if (
			createdAdspaceId &&
			isCreateAdspace &&
			!localStorage.getItem(createdAdspacesKey)?.includes(`"${createdAdspaceId}"`) &&
			appConfig?.user?.user_id
		) {
			localStorage.setItem(
				createdAdspacesKey,
				`${localStorage.getItem(createdAdspacesKey) || ''}, "${createdAdspaceId}"`,
			);
			sendYmEvent({
				event: EYmEvents.SEND_ADD_ADSPACE_SUCCESS,
				o1: [EYmEventsO1.ACCOUNT, EYmEventsO1.PUBLISHER, EYmEventsO1.ADSPACE],
				o2: EYmEventsO2.ADD_ADSPACE,
				wi: createdAdspaceId,
			});
		}
	}, [createdAdspaceId, isCreateAdspace, appConfig?.user?.user_id]); // eslint-disable-line react-hooks/exhaustive-deps

	const { data: adspaceList } = useGetAdspaceListQuery(`limit=${META_REQUEST_LIMIT}`);

	const adspacesCount = adspaceList?.results?.length;
	const createAdspaceUrl = appConfig?.mitgo_create_adspace_url;
	const callbackUrl = new URL(`${window.location.origin}/${EMainRoutes.SOURCES}/`);
	callbackUrl.searchParams.append('connectSourceModal', 'true');
	callbackUrl.searchParams.append('isCreateAdspace', 'true');
	const createAdspaceFullUrl = `${createAdspaceUrl}&callback_url=${encodeURIComponent(callbackUrl.href)}`;

	useEffect(() => {
		if (
			adspacesCount === 0 &&
			createAdspaceUrl &&
			!createdAdspaceId &&
			!localStorage.getItem(createdAdspacesKey) &&
			!appConfig?.is_super_login
		) {
			if (!localStorage.getItem(createdUserKey)) {
				sendYmEvent({
					event: EYmEvents.SEND_REGISTRATION_SUCCESS,
					o1: [EYmEventsO1.ACCOUNT, EYmEventsO1.PUBLISHER],
					o2: EYmEventsO2.REGISTRATION,
					o4: EYmEventsO4.PUBLISHER,
					reachGoal: EYmEventsGoals.SEND_REGISTRATION_SUCCESS_PUBLISHER,
				});
				localStorage.setItem(createdUserKey, 'true');
			}

			window.location.replace(createAdspaceFullUrl);
		}
	}, [adspacesCount, createAdspaceUrl, createdAdspaceId, appConfig?.user?.user_id]); // eslint-disable-line react-hooks/exhaustive-deps

	return { createAdspaceUrl, createAdspaceFullUrl };
};
